import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";
import { makeStyles } from "@material-ui/core/styles";
import HealthReminderForDietitianBooking from "../healthinfo/HealthReminderForDietitianBooking";
import DietInfoReminderForDietitianBooking from "../dietInfo/DietInfoReminderForDietitianBooking";

import HealthReminderForDietitianBooking2 from "../healthinfo/HealthReminderForDietitianBooking2";
import { useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

const useProfileState = createPersistedState("profile");

const useStyles = makeStyles(() => ({
  doctorItem: {
    display: "block",
    padding: "14px 16px",
    marginBottom: 14,
    textDecoration: "none",
    borderRadius: 6,
    backgroundColor: "var(--lightorangecolorfive)",
    color: "var(--blackcolorone)",
    textAlign: "center",
    cursor: "pointer",

    "&$active": {
      backgroundColor: "var(--darkbluecolorone)",
      color: "var(--whitecolor)",
    },
  },

  active: {},

  doctorInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  doctorName: {
    fontSize: "var(--fs20)",
    fontWeight: 500,
    fontFamily: "var(--ffpoppins)",
  },

  doctorSpeciality: {
    fontSize: "0.85rem",
    color: "#6c757d",
    marginTop: 4,
  },

  activeSpeciality: {
    color: "#e6eef6",
  },
  doctorUnavailableMessage: {
    fontSize: "0.75rem",
    color: "#dc3545",
    marginTop: 6,
    textAlign: "center",
  },
  activeDoctorUnavailableMessage: {
    color: "#f8d7da",
  },
}));

const SelectDoctor = ({
  selectedClinic,
  selectClinic,
  recDoctor,
  setRecDoctor,
}) => {
  const { previousStep, nextStep, goToStep } = useWizard();
  const { t } = useTranslation();
  const [profile] = useProfileState();
  const classes = useStyles();
  const { search } = useLocation();
  const history = useHistory();

  const [isHealthReminderOpen, setIsHealthReminderOpen] = useState(false);

  const [isHealthReminder2Open, setIsHealthReminder2Open] = useState(false);
  const [isDietitianReminderOpen, setIsDietitianReminderOpen] = useState(false);

  const [isDietInfoFilledRecently, setIsDietInfoFilledRecently] =
    useState(false);

  const [healthInfoUpdateDismissed, setHealthInfoUpdateDismissed] =
    useState(false);

  useEffect(() => {
    // TODO: The following logic isn't obvious and is deeply embeded
    // lift this logic
    const isReschedule = new URLSearchParams(search).get("reschedule");
    const isOnline = new URLSearchParams(search).get("online");
    const isDietitian = new URLSearchParams(search).get("isDietitian");

    //this is to indicate if health info filled recentle during booking flow
    const isDietInfoRecentlyFilled = new URLSearchParams(search).get(
      "dietInfoFilled"
    );
    setIsDietInfoFilledRecently(isDietInfoRecentlyFilled === "true");

    // if user coming for reschedule
    if (Boolean(isReschedule) && isOnline === "true" && isDietitian == "true") {
      selectClinic("CC000007");
      setRecDoctor({ drId: "DT000006", drName: "Dietitian" });
      goToStep(2);
    } else if (isDietInfoRecentlyFilled) {
      selectClinic("CC000007");
      setRecDoctor({ drId: "DT000006", drName: "Dietitian" });
      goToStep(2);
    } else if (Boolean(isReschedule) && isOnline === "true") {
      selectClinic("CC000000");
      goToStep(2);
    } else if (Boolean(isReschedule)) {
      goToStep(1);
    } else {
    }
  }, []);

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => history.push("/my-appointments")}
        title={t("appointment.DOCTOR.doctorSelectTitle")}
      />

      <div className="body_content py-5">
        <div className="inner_body">
          <ul className="list-unstyled ">
            {profile.healthProviders.map((doctor) => {
              const isActive = recDoctor?.drId === doctor.code;

              //This indicates if the other doctor is unavailable and this doctor will see the patient instead
              const doctorUnavailableMessage = doctor?.unavailableDoctorMessage
                ? t("appointment.DOCTOR.unavailable_message", {
                    unavailable: t(
                      `onboard.TREATING_DOC.options.${doctor?.unavailableDoctorMessage}`
                    ),
                    available: t(`onboard.TREATING_DOC.options.${doctor.code}`),
                  })
                : null;

              const doctorSpeciality =
                t(`appointment.DOCTOR.specialities.${doctor?.speciality}`) ||
                "";

              return (
                <li key={doctor.code}>
                  <Link
                    to="#"
                    onClick={() => {
                      if (doctor.code === "DT000006") {
                        // updateSelectedHCProvider("dietitian");
                        if (
                          !isDietInfoFilledRecently &&
                          !healthInfoUpdateDismissed
                        ) {
                          if (!profile?.healthInfoFilled) {
                            setIsHealthReminderOpen(true);
                          } else {
                            setIsHealthReminder2Open(true);
                          }
                        } else if (profile?.dietInfoFilled === false) {
                          setIsDietitianReminderOpen(true);
                        } else {
                          setRecDoctor({
                            drId: "DT000006",
                            drName: "Dietitian",
                          });
                          selectClinic("CC000007");
                          goToStep(3);
                        }
                        return;
                      }

                      setRecDoctor({
                        drId: doctor.code,
                        drName: doctor.name,
                      });
                      nextStep();
                    }}
                    className={`${classes.doctorItem} ${
                      isActive ? classes.active : ""
                    }`}
                  >
                    <div className={classes.doctorInfo}>
                      <div className={classes.doctorName}>
                        {t(`onboard.TREATING_DOC.options.${doctor.code}`)}
                      </div>
                      <div
                        className={`${classes.doctorSpeciality} ${
                          isActive ? classes.activeSpeciality : ""
                        }`}
                      >
                        {doctorSpeciality}
                      </div>
                      {doctor?.unavailableDoctorMessage &&
                        doctorUnavailableMessage && (
                          <div
                            className={`${classes.doctorUnavailableMessage} ${
                              isActive
                                ? classes.activeDoctorUnavailableMessage
                                : ""
                            }`}
                          >
                            {doctorUnavailableMessage}
                          </div>
                        )}
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      {isHealthReminderOpen && (
        <HealthReminderForDietitianBooking
          isHealthInfoFilled={profile?.healthInfoFilled}
          show={isHealthReminderOpen}
          dismiss={() => setIsHealthReminderOpen(false)}
        />
      )}
      {isHealthReminder2Open && (
        <HealthReminderForDietitianBooking2
          show={isHealthReminder2Open}
          dismiss={() => {
            setIsHealthReminder2Open(false);
            setHealthInfoUpdateDismissed(true);
            setRecDoctor({ drId: "DT000006", drName: "Dietitian" });
            selectClinic("CC000007");

            if (profile?.dietInfoFilled) {
              goToStep(2);
            } else {
              setIsDietitianReminderOpen(true);
            }
          }}
        />
      )}
      {isDietitianReminderOpen && (
        <DietInfoReminderForDietitianBooking
          show={isDietitianReminderOpen}
          dismiss={() => setIsDietitianReminderOpen(false)}
        />
      )}
    </>
  );
};

export default SelectDoctor;
